import {Component, HostBinding, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthError, AuthService} from '@innobile/authmodule';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private errMsg = $localize`:@@login.error:Invalid e-mail/password`;
  private redirect: string;

  @HostBinding('class.health') private isHealth = (environment as any).isHealth;

  formGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.email, Validators.required]),
    password: new UntypedFormControl('', [Validators.required])
  });

  constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('redirect')) {
        this.redirect = params.redirect;
      }
    });
  }

  login() {
    if (this.formGroup.valid) {
      this.auth.logIn({
        email: this.formGroup.controls.email.value,
        password: this.formGroup.controls.password.value
      }).subscribe(() => {
        const redirect = this.redirect ? this.redirect : '';
        this.redirect = null;
        this.router.navigateByUrl(redirect);
      }, error => {
        console.error(error);
        if (error instanceof AuthError) {
          this.formGroup.setErrors({form: this.errMsg});
        }
      });
    }
  }
}
